﻿
const sectionMap = {
    'IncomeSources_Spaargeld': 'section-savings',
    'IncomeSources_Beleggingen': 'section-investment',
    'IncomeSources_CryptoValuta': 'section-crypto',
    'IncomeSources_OverwaardeWoning': 'section-surplus',
    'IncomeSources_GeldUitEigenOnderneming': 'section-ownbusiness',
    'IncomeSources_Schenking': 'section-gift',
    'IncomeSources_Erfenis': 'section-heritage',
    'IncomeSources_UitkeringLevensverzekering': 'section-insurance',
    'IncomeSources_LeningOfKrediet': 'section-loan',
    'IncomeSources_Overig': 'section-other',
};

export function initRedemptionQuestions() {

    updateSectionVisibility();

    Object.keys(sectionMap).forEach((inputId) => {
        const checkbox = document.getElementById(inputId);
        if (checkbox && checkbox.type === 'checkbox') {
            checkbox.addEventListener('change', updateSectionVisibility);
        }
    });

}

function updateSectionVisibility() {
    for (const [inputId, sectionId] of Object.entries(sectionMap)) {
        const section = document.getElementById(sectionId);
        if (!section) continue;

        let checkbox = document.getElementById(inputId);

        if (checkbox && checkbox.type === 'checkbox') {
            section.hidden = !checkbox.checked;
        } else {
            const hiddenInput = document.querySelector(
                `input[type="hidden"][id="${inputId}"]`
            );

            if (hiddenInput) {
                const isChecked = String(hiddenInput.value).toLowerCase() === 'true';
                section.hidden = !isChecked;
            }
        }
    }
}